import {
  EntityIconBase,
  type EntityIconAppearance,
  type EntityIconDensity,
} from './entity-icon-base';
import { TerminalIcon } from '@terra/ui-icons';

type IconEndpointProps = {
  appearance?: EntityIconAppearance;
  density?: EntityIconDensity;
};

export function IconEndpoint({ appearance, density }: IconEndpointProps) {
  return (
    <EntityIconBase
      icon={TerminalIcon}
      bg="bg.entity.assets"
      color="fg.entity.assets"
      borderColor="border.entity.assets"
      appearance={appearance}
      density={density}
    />
  );
}
